<template>
    <section aria-label="object-location">
        <div class="table-grid row">
            <div class="col">
                <img
                    v-if="data.icon?.fullpath"
                    :src="apiUrl + data.icon.fullpath"
                    width="30"
                />
            </div>
            <div class="col" v-html="data.name"/>
            <div class="col">
                <div>
                    <a
                        v-if="data.link"
                        :href="data.link?.path"
                        target="_blank"
                        style="text-decoration: none"
                    >
                        <v-icon> mdi-information</v-icon>
                    </a>
                    <template v-if="item.metadata[0].value">
                        <span v-if="item.metadata[0].value === 'open'" class="status-open">
                            <template v-if="data.opentimes">
                                <span
                                    v-for="(opentime, i) in data.opentimes"
                                    :key="i"
                                    class="green-text"
                                >
                                    {{ opentime.open }} - {{ opentime.close }}
                                </span>
                            </template>
                            <span v-else>Geöffnet</span>
                        </span>
                        <span class="status-closed" style="color: red" v-else>Geschlossen</span>
                    </template>
                    <span v-if="data.info">{{ data.info }}</span>

                    <v-icon> mdi-phone</v-icon>
                    <a :href="'tel:' + data.telephone" class="no-wrap telephone">
                        {{ data.telephone }}
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import { defineProps } from 'vue'

const apiUrl = process.env.VUE_APP_API_URL

defineProps({
    data: Object,
    item: Object,
    stepsMade: {
        type: Number,
        default: 0
    }
})
</script>

<style lang="css" scoped>
span.no-wrap {
    white-space: nowrap;
}
</style>
